module.exports = __webpack_public_path__ + "static/media/active-days-image.54926784.webp";